import { combineReducers } from 'redux';
import { configureStore, Middleware } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';
import rootSaga from '../sagas';
import { createUserAccessMiddleware } from '../middlewares';

const browserHistory = createBrowserHistory();

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({ history: browserHistory });

const sagaMiddleware = createSagaMiddleware();

const userAccessMiddleware = createUserAccessMiddleware();

const prependMiddleware: Middleware[] = [userAccessMiddleware];
const appendMiddleware: Middleware[] = [routerMiddleware, sagaMiddleware];

if (import.meta.env.VITE_NODE_ENV === 'development') {
  const logger = createLogger();
  // appendMiddleware.push(logger);
}

const combinedReducer = combineReducers({
  router: routerReducer,
  ...rootReducer,
});

const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
    })
      .prepend(...prependMiddleware)
      .concat(...appendMiddleware),
});

const history = createReduxHistory(store);

sagaMiddleware.run(rootSaga);

// Exposed for the E2E spec (tests/e2e/trace-viewer-frame.spec.ts) only, so it
// can dispatch into the live store; never relied on in production.
if (import.meta.env.DEV) {
  (window as any).__store__ = store;
}

export { store, history };
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
